import { NextApiRequest, NextApiResponse } from 'next';
import type { Request, Response, Router } from 'express';
import axios from 'axios';
import environment from '../../../config/environment';

// Define interfaces for our data
interface Form990Data {
  // Add your form data structure here
  organizationName?: string;
  ein?: string;
  // ... other fields
}

// Add missing interfaces
interface Form990QuestionnaireSubmission {
  fiscalSponsorId: string;
  responses: Record<string, any>;
  submittedBy?: string;
  submittedAt?: string;
}

// Add getApiUrl function
const getApiUrl = (): string => {
  const env = environment();
  return env.apiUrl || '';
};

// Next.js API handler
export default async function handler(req: NextApiRequest, res: NextApiResponse) {
  if (req.method !== 'POST') {
    return res.status(405).json({ message: 'Method not allowed' });
  }

  try {
    // Your handler code here
    const {
      fiscalSponsorId,
      responses,
      submittedBy,
      status = 'DRAFT'
    } = req.body;

    // Process the request
    // ...

    return res.status(200).json({
      success: true,
      message: 'Form 990 questionnaire saved successfully'
    });

  } catch (err) {
    console.error('Error processing Form 990:', err);
    
    return res.status(500).json({
      success: false,
      message: 'Failed to process Form 990',
      error: err instanceof Error ? err.message : 'Unknown error'
    });
  }
}

// Export API methods for client use
export const form990API = {
  submitQuestionnaire: async (data: Form990QuestionnaireSubmission) => {
    try {
      const baseURL = getApiUrl();
      const response = await axios.post(
        `${baseURL}/api/templates/form990`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error submitting questionnaire:', error);
      throw error;
    }
  },

  getDraft: async (fiscalSponsorId: string) => {
    try {
      const baseURL = getApiUrl();
      const response = await axios.get(
        `${baseURL}/api/templates/form990/draft`,
        { params: { fiscalSponsorId } }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching Form 990 draft:', error);
      throw error;
    }
  },

  generateForm990PDF: async (formData: any) => {
    try {
      const baseURL = getApiUrl();
      const response = await axios.post(
        `${baseURL}/api/templates/form990/generate`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error('Error generating Form 990:', error);
      throw error;
    }
  },

  testConnection: async () => {
    const baseURL = getApiUrl();
    return axios.get(`${baseURL}/api/templates/form990/ping`);
  }
};

// Server-side only code - this will not be included in the client bundle
export const createForm990Handler = () => {
  // Only require express at runtime when this function is called
  const express = require('express');
  const router = express.Router();
  
  // Define your routes
  router.post('/generate', async (req: Request, res: Response) => {
    try {
      const formData = req.body;
      // Your form generation logic here
      
      res.status(200).json({ success: true, message: 'Form 990 generated successfully' });
    } catch (error) {
      console.error('Error generating Form 990:', error);
      res.status(500).json({ success: false, message: 'Failed to generate Form 990' });
    }
  });
  
  return router;
};